"use client";

import { useCallback } from "react";
import { useAnalyticsContext, TrackingEvent, ProductType } from "@/analytics";

function normalizeDateForDataLayer(dateValue) {
  if (dateValue == null || dateValue === "") return null;
  if (typeof dateValue !== "string") return null;
  const datePart = dateValue.split("T")[0].trim();
  if (!datePart) return null;
  // "2026.03.22" -> "2026-03-22"
  const normalized = datePart.replace(/\./g, "-");
  return normalized;
}

/**
 * "Haritada Göster" tıklandığında hotel_map_view dataLayer event'ini tetikler.
 * Detail Header, Search (MapViewModal) ve Search mobil butonunda kullanılır.
 * Olmayan veriler null basar.
 *
 * @param {Object} params
 * @param {string} [params.hotel_city]
 * @param {string} [params.hotel_district]
 * @param {string} [params.hotel_neighborhood]
 * @param {string} [params.hotel_country]
 * @param {string} [params.hotel_region]
 * @param {string} [params.state] - yurtdışı oteller için; yurtiçi için null
 * @param {number} [params.guest_total]
 * @param {number} [params.guest_adult_number]
 * @param {number} [params.guest_children_number]
 * @param {string} [params.start_date] - YYYY-MM-DD
 * @param {string} [params.end_date] - YYYY-MM-DD
 * @returns {{ trackHotelMapView: () => void }}
 */
export function useHotelMapViewAnalytics({
  hotel_city,
  hotel_district,
  hotel_neighborhood,
  hotel_country,
  hotel_region,
  state,
  guest_total,
  guest_adult_number,
  guest_children_number,
  start_date,
  end_date,
}) {
  const { dispatch: trackingDispatch } = useAnalyticsContext();

  const trackHotelMapView = useCallback(() => {
    trackingDispatch({
      type: TrackingEvent.HOTEL_MAP_VIEW,
      payload: {
        productType: ProductType.HOTEL,
        hotel_city: hotel_city ?? null,
        hotel_district: hotel_district ?? null,
        hotel_neighborhood: hotel_neighborhood ?? null,
        hotel_country: hotel_country ?? null,
        hotel_region: hotel_region ?? null,
        state: state ?? null,
        guest_total: guest_total ?? null,
        guest_adult_number: guest_adult_number ?? null,
        guest_children_number: guest_children_number ?? null,
        start_date: normalizeDateForDataLayer(start_date),
        end_date: normalizeDateForDataLayer(end_date),
      },
    });
  }, [
    hotel_city,
    hotel_district,
    hotel_neighborhood,
    hotel_country,
    hotel_region,
    state,
    guest_total,
    guest_adult_number,
    guest_children_number,
    start_date,
    end_date,
    trackingDispatch,
  ]);

  return { trackHotelMapView };
}
